module.exports = __webpack_public_path__ + "static/media/student-game-comment-watch.09d64e1a.png";